document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.querySelector('[data-sticky-buy]');
  const stickyBtn = stickyBar?.querySelector('[data-sticky-buy-btn]');
  const stickyPriceWrapper = stickyBar?.querySelector('[data-sticky-price]');
  const mainForm = document.querySelector('.product-form');
  const mainSubmit = mainForm?.querySelector('[data-add-to-cart]');
  const mainPriceBlock = document.querySelector('.product__price');
  const root = document.documentElement;

  if (!stickyBar || !stickyBtn || !mainSubmit || !mainPriceBlock) return;

  // --- 1. Start hidden ---
  stickyBar.classList.remove('visible');
  root.style.setProperty('--product-sticky-buy-bar-height', '0px');

  // --- 2. Toggle bar visibility based on scroll position ---
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const isVisible = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        const shouldShow = !isVisible;

        stickyBar.classList.toggle('visible', shouldShow);
        root.style.setProperty(
          '--product-sticky-buy-bar-height',
          shouldShow ? '69px' : '0px'
        );
      });
    },
    { threshold: 0 }
  );
  observer.observe(mainSubmit);

  // --- 3. Mirror click: trigger main form submit ---
  stickyBtn.addEventListener('click', () => {
    if (!mainSubmit.disabled && !mainSubmit.classList.contains('is-unavailable')) {
      mainSubmit.click();
    }
  });

  // --- 4. Mirror full price block ---
  const updateFullPriceBlock = () => {
    if (!mainPriceBlock || !stickyPriceWrapper) return;
    stickyPriceWrapper.innerHTML = mainPriceBlock.outerHTML;
  };
  updateFullPriceBlock();
  document.addEventListener('variant:change', updateFullPriceBlock);
  document.addEventListener('product:variant-change', updateFullPriceBlock);
  new MutationObserver(updateFullPriceBlock).observe(mainPriceBlock.parentNode, {
    childList: true,
    subtree: true,
  });

  // --- 5. Sync button text and visual state ---
  const syncButtonState = () => {
    if (!mainSubmit || !stickyBtn) return;

    // Text
    const sourceSpan = mainSubmit.querySelector('[data-add-to-cart-text]');
    const targetSpan = stickyBtn.querySelector('[data-add-to-cart-text]');
    const mainText = sourceSpan ? sourceSpan.textContent : mainSubmit.textContent.trim();
    if (targetSpan) targetSpan.textContent = mainText;
    else stickyBtn.textContent = mainText;

    // Disabled / Unavailable
    const isDisabled = mainSubmit.disabled || mainSubmit.classList.contains('is-unavailable');
    stickyBtn.disabled = isDisabled;

    // Mirror loading and availability classes
    const importantClasses = [
      'loading',
      'is-unavailable',
      'btn--disabled',
      'btn--primary',
      'btn--secondary',
      'sold-out',
    ];

    const baseClasses = stickyBtn.dataset.baseClassList || stickyBtn.className;
    stickyBtn.dataset.baseClassList = baseClasses;
    stickyBtn.className = baseClasses
      .split(' ')
      .filter((cls) => !importantClasses.includes(cls))
      .concat(
        importantClasses.filter((cls) => mainSubmit.classList.contains(cls))
      )
      .join(' ');
  };

  const buttonObserver = new MutationObserver(syncButtonState);
  buttonObserver.observe(mainSubmit, {
    attributes: true,
    attributeFilter: ['disabled', 'class'],
    childList: true,
    subtree: true,
  });

  syncButtonState();
});
